export enum Type {
  Bike = "bike",
  Accessory = "accessory"
}

export const fromATData = (type: "Bike" | "Accessory") => {
  switch (type) {
    case "Bike":
      return Type.Bike;
    case "Accessory":
      return Type.Accessory;
  }
};

export const toATData = (type: Type): "Bike" | "Accessory" => {
  switch (type) {
    case Type.Bike:
      return "Bike";
    case Type.Accessory:
      return "Accessory";
  }
};
